import React, { useContext } from 'react'

export function loadEnvironmentVariables(): EnvironmentContextValues {
  return {
    googlePlaceAPIKey: process.env.GOOGLE_PLACE_API_KEY || '',
    grafanaFaroCollectorURL: process.env.GRAFANA_FARO_COLLECTOR_URL || '',
    deployEnv: process.env.DEPLOY_ENV || ''
  }
}

export type EnvironmentContextValues = {
  googlePlaceAPIKey: string
  grafanaFaroCollectorURL: string
  deployEnv: string
}

export const EnvironmentContext = React.createContext<EnvironmentContextValues>({
  googlePlaceAPIKey: '',
  grafanaFaroCollectorURL: '',
  deployEnv: ''
})

export const useEnvironmentContext = () => {
  return useContext(EnvironmentContext)
}

const EnvironmentProvider = ({
  children,
  environmentVariables
}: {
  children: React.ReactNode
  environmentVariables: EnvironmentContextValues
}) => {
  const value: EnvironmentContextValues = {
    googlePlaceAPIKey: environmentVariables.googlePlaceAPIKey,
    grafanaFaroCollectorURL: environmentVariables.grafanaFaroCollectorURL,
    deployEnv: environmentVariables.deployEnv
  }

  return <EnvironmentContext.Provider value={value}>{children}</EnvironmentContext.Provider>
}

export default EnvironmentProvider
